export class Employee {
  constructor(
    public id: string,
    public username: string,
    public firstName: string,
    public lastName: string,
    public email: string|null,
    public role: "employee"|"office",
    public roles: string[],
    public enabled: boolean,
    public metadata: EmployeeMetadata,
  ) {
  }

  static fromJson(json: any): Employee {
    return new Employee(
      json['id'],
      json['username'],
      json['firstName'],
      json['lastName'],
      json['email'],
      json['role'],
      json['roles'] ?? [],
      json['enabled'],
      json['metadata'] ? EmployeeMetadata.fromJson(json['metadata']) : new EmployeeMetadata(null, false, null, false, false, true, false, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null),
    );
  }
}

export class EmployeeMetadata {
  constructor(
    public readonly archivedAt: Date|null,
    public readonly isBsnSet: boolean,
    public readonly color: string|null,
    public readonly hasTravelCompensation: boolean,
    public readonly hasAllInSalary: boolean,
    public readonly includeInHoursExport: boolean,
    public readonly shadowEmployee: boolean,
    public readonly contractStartDate: Date|null,
    public readonly contractEndDate: Date|null,
    public readonly employeeType: string|null,

    public readonly emergencySelfName: string|null,
    public readonly emergencySelfAddress: string|null,
    public readonly emergencySelfStreetname: string|null,
    public readonly emergencySelfHouseNumber: string|null,
    public readonly emergencySelfHouseNumberAddition: string|null,
    public readonly emergencySelfZipcode: string|null,
    public readonly emergencySelfCity: string|null,
    public readonly emergencySelfDateOfBirth: Date|null,
    public readonly emergencySelfPhone: string|null,
    public readonly emergencySelfAllergies: string|null,
    public readonly emergencySelfNote: string|null,

    public readonly emergencyContactName: string|null,
    public readonly emergencyContactPhone: string|null,
    public readonly emergencyContactAddress: string|null,
    public readonly emergencyContactStreetname: string|null,
    public readonly emergencyContactHouseNumber: string|null,
    public readonly emergencyContactHouseNumberAddition: string|null,
    public readonly emergencyContactZipcode: string|null,
    public readonly emergencyContactCity: string|null,

    public readonly emergencyGpName: string|null,
    public readonly emergencyGpPhone: string|null,
    public readonly emergencyGpAddress: string|null,
    public readonly emergencyGpStreetname: string|null,
    public readonly emergencyGpHouseNumber: string|null,
    public readonly emergencyGpHouseNumberAddition: string|null,
    public readonly emergencyGpZipcode: string|null,
    public readonly emergencyGpCity: string|null,

  ) {
  }

  static fromJson(json: any): EmployeeMetadata {
    return new EmployeeMetadata(
      json['archived_at'] ? new Date(json['archived_at']) : null,
      json['bsn_set'],
      json['color'],
      json['has_travel_compensation'],
      json['has_all_in_salary'],
      json['include_in_hours_export'],
      json['shadow_employee'] ?? false,
      json['contract_start_date'] ? new Date(json['contract_start_date']) : null,
      json['contract_end_date'] ? new Date(json['contract_end_date']) : null,
      json['employee_type'],
      json['emergency_self_name'],
      json['emergency_self_address'],
      json['emergency_self_streetname'],
      json['emergency_self_house_number'],
      json['emergency_self_house_number_addition'],
      json['emergency_self_zipcode'],
      json['emergency_self_city'],
      json['emergency_self_date_of_birth'] ? new Date(json['emergency_self_date_of_birth']) : null,
      json['emergency_self_phone'],
      json['emergency_self_allergies'],
      json['emergency_self_note'],
      json['emergency_contact_name'],
      json['emergency_contact_phone'],
      json['emergency_contact_address'],
      json['emergency_contact_streetname'],
      json['emergency_contact_house_number'],
      json['emergency_contact_house_number_addition'],
      json['emergency_contact_zipcode'],
      json['emergency_contact_city'],
      json['emergency_gp_name'],
      json['emergency_gp_phone'],
      json['emergency_gp_address'],
      json['emergency_gp_streetname'],
      json['emergency_gp_house_number'],
      json['emergency_gp_house_number_addition'],
      json['emergency_gp_zipcode'],
      json['emergency_gp_city'],
    );
  }

  getEmployeeTypeName(): string|null {
    return this.employeeType !== null ? (
      employeeTypesOptions[this.employeeType as keyof typeof employeeTypesOptions] ?? this.employeeType
    ) : null;
  }
}

export const employeeTypesOptions = {
  P: '(P) Personeel',
  W: '(W) Personeel (3e)',
  Z: '(Z) ZZP',
}
export type EmployeeType = keyof typeof employeeTypesOptions
